import { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { FiEdit2, FiTrash, FiExternalLink } from "react-icons/fi";
import ReactPaginate from "react-paginate";
import swal from "@sweetalert/with-react";
import Card from "../../components/Card";
import Loader from "../../components/Loader";
import BigLoader from "../../components/BigLoader";
import Button from "../../components/Button";
import Table, { Td, Th } from "../../components/Table";
import { setInterface } from "../../redux/slices/interfaceSlice";
import { frontendUrl } from "../../utils/landing";
import service from "../../service";

export default function LandingPage() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [postLoading, setPostLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const getData = () => {
    setLoading(true);
    service
      .get("/api/landing-pages", { params: { page } })
      .then((response) => {
        setData(response.data.data || []);
        setTotal(response.data.total || 0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const onDelete = (id) => {
    swal({
      title: "Anda yakin?",
      text: "Anda akan menghapus landing page ini",
      icon: "warning",
      buttons: ["Batal", true],
      dangerMode: true,
      cancelButton: "Batal",
    }).then((value) => {
      if (!value) return;
      setPostLoading(true);
      service
        .delete(`/api/landing-pages/${id}`)
        .then(() => {
          setPostLoading(false);
          getData();
          swal("Berhasil", "Landing page telah dihapus", "success");
        })
        .catch(() => setPostLoading(false));
    });
  };

  useEffect(() => {
    dispatch(
      setInterface({
        active: "Landing Page",
        pageTitle: "Landing Page",
        rightButton: {
          to: "/landing-page/add",
          label: "Tambah",
          color: "green",
          withPlusIcon: true,
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <Card>
      <Helmet>
        <title>Landing Page</title>
      </Helmet>
      {loading ? (
        <div className="h-64 flex justify-center items-center flex-col">
          <Loader className="bg-black-100" />
          <span className="mt-3 text-black-300 text-sm">Memuat</span>
        </div>
      ) : data.length ? (
        <Fragment>
          <Table>
            <thead>
              <tr>
                <Th>Nama</Th>
                <Th>Judul</Th>
                <Th>Slug</Th>
                <Th>Status</Th>
                <Th className="text-right">Aksi</Th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  <Td className="font-semibold text-black-200">{item.name}</Td>
                  <Td>{item.title}</Td>
                  <Td className="text-black-300">{item.slug}</Td>
                  <Td>
                    <span
                      className={
                        "inline-block px-2 py-1 rounded-sm text-xs font-semibold " +
                        (item.status === "published"
                          ? "bg-green-50 text-green-300"
                          : "bg-white-200 text-black-300")
                      }
                    >
                      {item.status === "published" ? "Published" : "Draft"}
                    </span>
                  </Td>
                  <Td>
                    <div className="flex items-center justify-end gap-2">
                      <a
                        href={frontendUrl(item.slug)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h-9 px-3 rounded-sm text-sm font-semibold inline-flex items-center bg-white-100 hover:bg-white-200 text-black-200 border border-white-300"
                      >
                        <FiExternalLink className="mr-1" /> Preview
                      </a>
                      <Button
                        link
                        to={`/landing-page/edit/${item.id}`}
                        noFixedHeight
                        className="h-9 px-3"
                      >
                        <FiEdit2 className="mr-1" /> Edit
                      </Button>
                      <Button
                        type="button"
                        color="red"
                        noFixedHeight
                        className="h-9 px-3"
                        onClick={() => onDelete(item.id)}
                      >
                        <FiTrash />
                      </Button>
                    </div>
                  </Td>
                </tr>
              ))}
            </tbody>
          </Table>
          <ReactPaginate
            pageCount={total}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            initialPage={page - 1}
            containerClassName="flex flex-wrap mt-6 gap-1"
            previousLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            nextLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            pageLinkClassName="border border-white-300 rounded-sm py-1.5 px-3 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 block"
            activeLinkClassName="bg-primary-500 border-primary-600 text-white-100"
            onPageChange={({ selected }) => setPage(selected + 1)}
          />
        </Fragment>
      ) : (
        <div className="text-center flex flex-col justify-center items-center h-40 text-black-300">
          <p>Belum ada Landing Page. Klik Tambah untuk membuat baru.</p>
        </div>
      )}
      {postLoading && <BigLoader />}
    </Card>
  );
}
